import React from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'

export default function BlankPage() {

    return (
        <>
            <Breadcrumb title="Blank Page" path="Pages / Blank Page" />
            <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                <div className='mb-30 text-[16px]/[19.2px] font-medium'>Stater Page</div>
                <div className='text-[24px]/[28.8px] font-medium'>Stater Page</div>
            </div>
        </>
    )
}
